import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NovaPasta } from '../../models/nova-pasta';
import { PastaService } from '../../services/pasta-service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-nova-pasta',
  templateUrl: './nova-pasta.component.html',
  styleUrls: ['./nova-pasta.component.css'],
  standalone: false
})
export class NovaPastaComponent {
  @Input() pessoaId: number;
  @Output() fecharModalCalled = new EventEmitter();
  @Output() atualizarListaCalled = new EventEmitter();

  showModalPasta = false;
  pasta = new NovaPasta();
  loading = false;

  constructor(
    private pastaService: PastaService,
    private toastr: ToastrService
  ) {}

  showModal(pessoaId: number) {
    this.pessoaId = pessoaId;
    this.pasta = new NovaPasta();
    this.pasta.pessoaId = this.pessoaId;
    this.showModalPasta = true;
  }

  fecharModalPasta() {
    this.showModalPasta = false;
    this.fecharModalCalled.emit();
  }

  salvarModalPasta() {
    if (!this.pasta.descricao) {
      this.toastr.error("A descrição da pasta é obrigatória.");
      return;
    }

    this.loading = true;
    this.pastaService.adicionar(this.pasta).subscribe(
      response => {
        this.loading = false;
        if (response.sucesso) {
          this.toastr.success("Pasta salva com sucesso");
          this.atualizarListaCalled.emit();
          this.fecharModalPasta();
        } else {
          this.toastr.error("Erro ao salvar a pasta: " + response.errors[0].mensagem);
        }
      },
      error => {
        this.loading = false;
        this.toastr.error("Erro ao salvar a pasta");
      }
    );
  }
}
